import { useState, type FormEvent } from 'react';
import { Mark } from '../components/Mark';

interface Props {
  onZaloguj: (email: string, haslo: string) => Promise<void>;
  blad: string | null;
}

export function LoginView({ onZaloguj, blad }: Props) {
  const [email, setEmail] = useState('');
  const [haslo, setHaslo] = useState('');
  const [wysylanie, setWysylanie] = useState(false);

  async function wyslij(event: FormEvent) {
    event.preventDefault();
    if (wysylanie) return;
    setWysylanie(true);
    try {
      await onZaloguj(email, haslo);
    } finally {
      setWysylanie(false);
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center px-18 py-34">
      <div className="w-full max-w-[380px]">
        <div className="mb-26 flex items-center gap-13">
          <Mark rozmiar={44} />
          <div>
            <div className="t-h1">Klindro</div>
            <div className="t-small text-n-600">Serwis maszyn odzieżowych</div>
          </div>
        </div>

        <form
          onSubmit={wyslij}
          className="border border-n-100 bg-surface p-22"
          noValidate
        >
          <h1 className="t-h2 mb-18">Zaloguj się</h1>

          <label className="t-label mb-9 block text-n-700" htmlFor="email">
            E-mail
          </label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mb-18 w-full border border-n-300 bg-surface px-13 text-n-900"
          />

          <label className="t-label mb-9 block text-n-700" htmlFor="haslo">
            Hasło
          </label>
          <input
            id="haslo"
            type="password"
            autoComplete="current-password"
            required
            value={haslo}
            onChange={(e) => setHaslo(e.target.value)}
            className="mb-18 w-full border border-n-300 bg-surface px-13 text-n-900"
          />

          {blad && (
            <p
              role="alert"
              className="t-small mb-18 border-l-[3px] border-status-failure bg-[var(--status-failure-bg)] px-13 py-10 text-[var(--status-failure-text)]"
            >
              {blad}
            </p>
          )}

          {/* Jedyny element w kolorze marki w tym widoku. */}
          <button
            type="submit"
            disabled={wysylanie}
            className="w-full border border-brand-600 bg-brand-500 px-18 text-surface disabled:border-n-300 disabled:bg-n-300"
          >
            <span className="t-body-strong">{wysylanie ? 'Logowanie…' : 'Zaloguj'}</span>
          </button>
        </form>
      </div>
    </main>
  );
}
